import React, { useCallback } from "react";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { EmvCard } from "@radarly/models/cards/model";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { getPostSortFromMetric } from "@radarly/models/posts";
import Date from "@radarly/shared/cards/subtitle/date";
import Metric from "@radarly/shared/cards/subtitle/metric";
import Tile from "@radarly/shared/cards/tile";
import Emv from "@radarly/shared/widgets/emv";
import { useFragments } from "../fragment";
import { CardProps } from "../model";

const RadarlyEmvCard = ({
  card,
  clause,
  from,
  to,
  height,
  timezone,
  openPostsPanel,
  nowDate,
}: CardProps<EmvCard>) => {
  const project = useCurrentProject();
  const fragments = useFragments(
    [card.fragments[0], card.fragments[1]],
    clause,
    from,
    to,
    timezone,
    undefined
  );
  const fragment = fragments[0];
  const title = card.title;
  const onClickItem = useCallback(() => {
    const { from, to } = getDateFromClause(fragment.request.query);
    openPostsPanel({
      clause: fragment.request.query,
      period: { from, to },
      title,
      sortBy: getPostSortFromMetric(fragment.request.aggs.date.metrics[0]),
      timezone,
    });
  }, [
    fragment.request.aggs.date.metrics,
    fragment.request.query,
    openPostsPanel,
    timezone,
    title,
  ]);
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <Metric metric={fragment.request.aggs.date.metrics[0]} />,
          ]}
        />
      }
      clause={fragment.request.query}
    >
      <Emv fragments={fragments} project={project} onClickItem={onClickItem} />
    </Tile>
  );
};

export default RadarlyEmvCard;
